import { getBootstrapData } from "@swa-ui/bootstrap";
import i18n from "@swa-ui/locale";

/**
 * getAircraftTypeByCarrierCodeAndEquipmentType is a method to return the details of a particular aircraft
 * by carrierCode and the equipmentType.
 *
 * @param {string} carrierCode
 * @param {string} equipmentType
 * @returns {{
 *  numberOfSeats: {number},
 *  aircraftType: {string},
 *  wifiSupported: {boolean}
 * }}
 */
export const getAircraftDetailsByCarrierCodeAndEquipmentType = (carrierCode, equipmentType) =>
  getBootstrapData("air/aircraft-information-data")?.[carrierCode]?.[equipmentType];

/**
 * getAircraftTypeByCarrierCodeAndEquipmentType is a method to return the aircraftType of a particular aircraft
 * by carrierCode and the equipmentType.
 *
 * @param {string} carrierCode
 * @param {string} equipmentType
 * @returns {string}
 */
export const getAircraftTypeByCarrierCodeAndEquipmentType = (carrierCode, equipmentType) =>
  getAircraftDetailsByCarrierCodeAndEquipmentType(carrierCode, equipmentType)?.aircraftType ??
  i18n("Aircrafts__UNKNOWN_EQUIPMENT");
